module.exports = "/images/img3.png?b21a2fb37244578bdef37dbc50a0bc15";